module.exports = __webpack_public_path__ + "static/media/ts8tj93.7340c07d.png";